module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "buy_recharge.e26d234d.png" + "?" + Date.now();